import { getContent } from '@ynap/content-state'

export default function getRewardsLanding(state, props) {
    const { locale } = state
    const { userSummary } = props

    const loyaltySegment = userSummary?.loyaltySegment
    const loyaltySegmentContentKey = `loyalty-${loyaltySegment}`
    /* TODO: ADD all the conditionals to render the different tier journeys in
    this or another file so we can return them here (for both the header and the sticky message) */

    return {
        userSummary,
        locale,
        content: getContent(state, loyaltySegmentContentKey),
        isFetchingContent: state?.content[loyaltySegmentContentKey]?.loading,
        fetchContentError: state?.content[loyaltySegmentContentKey]?.error,
    }
}
